import { render, staticRenderFns } from "./marchOutDetail.vue?vue&type=template&id=224a8fd6&"
import script from "./marchOutDetail.vue?vue&type=script&lang=js&"
export * from "./marchOutDetail.vue?vue&type=script&lang=js&"
import style0 from "./marchOutDetail.vue?vue&type=style&index=0&id=224a8fd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports